<template>
  <div class="card card-plan card-plan-skeleton py-4">
    <div class="card-plan__header text-center">
      <div class="sk-block sk-title"></div>
      <div class="sk-block sk-subtitle"></div>
    </div>

    <div class="card-plan__price text-center my-4">
      <div class="sk-block sk-price"></div>
      <div class="sk-block sk-period"></div>
    </div>

    <div class="card-plan__features">
      <div class="sk-feature" v-for="n in featureCount" :key="n">
        <div class="sk-block sk-icon"></div>
        <div class="sk-block sk-text" :style="{ width: textWidth(n) }"></div>
      </div>
    </div>

    <div class="card-plan__action">
      <div class="sk-block sk-button"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlanCardSkeleton",
  props: {
    featureCount: { type: Number, default: 4 }
  },
  methods: {
    textWidth(n) {
      const widths = ["75%", "60%", "50%", "65%", "55%", "45%", "70%"];
      return widths[(n - 1) % widths.length];
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.sk-block {
  background: linear-gradient(90deg, #f0f2f7 25%, #e8ecf5 50%, #f0f2f7 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 6px;
}

.card-plan-skeleton {
  pointer-events: none;
}

.sk-title {
  width: 120px;
  height: 22px;
  margin: 0 auto 8px;
}

.sk-subtitle {
  width: 160px;
  height: 14px;
  margin: 0 auto;
}

.sk-price {
  width: 80px;
  height: 42px;
  margin: 0 auto 8px;
}

.sk-period {
  width: 60px;
  height: 14px;
  margin: 0 auto;
}

.sk-feature {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f0f1f5;

  &:last-child {
    border-bottom: none;
  }
}

.sk-icon {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-right: 8px;
  flex-shrink: 0;
}

.sk-text {
  height: 13px;
}

.sk-button {
  width: 100%;
  height: 44px;
  border-radius: 10px;
  margin-top: 1rem;
}

.card-plan__features {
  padding: 0 1.5rem;
  margin-top: 1rem;
}

.card-plan__action {
  padding: 0 1.5rem;
}
</style>
